import { FC } from 'react'

interface ImpostorProps {
  onContinue: () => void
}

const Impostor: FC<ImpostorProps> = ({ onContinue }) => {
  return (
    <div className='fixed inset-0 z-20 pointer-events-auto'>
      {/* Overlay with white and opacity */}
      <div className='absolute inset-0 bg-white opacity-60'></div>
      {/* Content anchored to bottom */}
      <div className='absolute inset-x-0 bottom-0 flex flex-col items-center px-4 pb-8'>
        <div className='w-full max-w-sm flex flex-col items-center'>
          {/* Text */}
          <div className='w-full text-center font-medium text-base text-[#222] mb-5'>
            Resume session once you have found
            <br />
            the registered user
          </div>
          {/* Button */}
          <button
            className='w-full h-[50px] border-none rounded-md bg-blue-500 text-white font-semibold text-xl cursor-pointer shadow-[0_4px_18px_rgba(89,156,255,0.17)]'
            onClick={onContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  )
}

export default Impostor
